export default "__VITE_ASSET__BiMTa2PI__"